import { captureExceptionon } from '@sentry/react';
import { ColorCodeAddApi, ColorCodeDeleteApi } from '../../../../api/materials';
import { dispatcher } from '../../../../helpers/projectHelper';
import { setCuratorLoader } from '../../../../redux/slicers/admin/curatorSlicer';
import { paginatedColorActions } from '../../../../redux/slicers/admin/paginatedColorSlicer';

export class UndoRedoColorSwatches {
  constructor({ undoRedoInstance }) {
    this.undoRedo = undoRedoInstance;

    this.init();
  }

  init = () => {
    this.deleteSwatchItem = this.undoRedo.createAction(({ item }) => {
      const itemCopy = { ...item };

      const getId = () => itemCopy.id;

      const historyValue = {
        data: {
          item: itemCopy,
        },
        undo: async () => {
          dispatcher(setCuratorLoader(false));
          const result = await dispatcher(
            ColorCodeAddApi({
              color: itemCopy.color_value,
              memberId: itemCopy.member,
            })
          );

          if (!result?.data?.id) {
            //captureException(new Error('Unable to undo delete swatch item LF_9797234897234'));
          } else {
            itemCopy.id = result?.data?.id;
          }

          dispatcher(setCuratorLoader(true));
        },
        redo: async () => {
          dispatcher(setCuratorLoader(false));
          const result = await dispatcher(ColorCodeDeleteApi({ id: getId() }));

          if (!result?.status) {
            //captureException(new Error('Unable to redo delete swatch item LF_9797234897234'));
          }
          dispatcher(setCuratorLoader(true));
        },
      };
      return historyValue;
    });

    this.addSwatchItem = this.undoRedo.createAction(({ item }) => {
      const itemCopy = { ...item };
      const historyValue = {
        data: { item: itemCopy },
        undo: async () => {
          dispatcher(setCuratorLoader(false));
          const result = await dispatcher(ColorCodeDeleteApi({ id: itemCopy.id }));

          if (!result?.status) {
            //captureException(new Error('Unable to undo add swatch item LF_97972348972394'));
          }
          dispatcher(setCuratorLoader(true));
        },
        redo: async () => {
          dispatcher(setCuratorLoader(false));
          const result = await dispatcher(
            ColorCodeAddApi({
              color: itemCopy.color_value,
              memberId: itemCopy.member,
            })
          );

          if (!result?.data?.id) {
            //captureException(new Error('Unable to redo add swatch item LF_97972348972034'));
          } else {
            itemCopy.id = result?.data?.id;
          }

          dispatcher(setCuratorLoader(true));
        },
      };
      return historyValue;
    });
  };
}
